import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettingsDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 15,
	viewBox: "0 0 13 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .7,
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.5 6.15734C1.22386 6.15734 1 5.93349 1 5.65734V5.2703C1 4.33209 1.79746 3.56445 2.77213 3.56445H10.3037C11.2783 3.56445 12.0758 4.33209 12.0758 5.2703V5.83646C12.0758 6.1126 11.8519 6.33646 11.5758 6.33646H10.9682V12.2934C10.9682 13.2317 10.1708 13.9993 9.1961 13.9993H3.87971C2.90504 13.9993 2.10758 13.2317 2.10758 12.2934V6.15734H1.5Z",
			stroke: "#FF4C4D",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.60693 2.99923V1.99846C4.60693 1.62226 4.88728 1.31445 5.22992 1.31445H7.59102C7.93366 1.31445 8.21401 1.62226 8.21401 1.99846V2.99923",
			stroke: "#FF4C4D",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		})]
	})
});
export default SvgSettingsDelete;
